/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(2300) FIXME: Duplicate identifier 'MenuManagerService'.
class MenuManagerService {
   allClosed: any
   content: any
   hasContent: any
   menu: any
   open: any
   pinned: any
   subMenu: any
   constructor(){
      // define the screen sizes for which the panels are opened by default. These can be overridden by the user.
      // if not defined, the panels are closed by default.
      // the type can be 'panel' or 'menu' - panels are parts of the page, but menus are overlayed / expandable menus
      // screen sizes: xs, sm, md, lg, xl, any ('any' is used to close whenever the screensize changes)
      // the definition is done from HTML source
      this.registerMenu = this.registerMenu.bind(this)
      this.menu = {}
      this.subMenu = {}
   }

   // This method is used to add open/close behavior to a menu. A menu can also be registered from a directive (like translatableTextWithDropdown and MoreAction)
   // it then can be used for example by the accessibility thingy to close all open submenus on hitting 'esc' button.
   registerMenu(controllerScope: any) {
      controllerScope.open = false
      controllerScope.openMenu = this.openMenu
      controllerScope.closeMenu = this.closeMenu
      controllerScope.pin = this.pin
      controllerScope.unpin = this.unpin
      // assume there is content, unless others say they didn't add any content
      // this can be used later to determine if the panel is empty, and if it should be shown or not
      // usually menus don't implement this, but the thirdPanel has many sections, and they all might not add content, then we can hide it...
      controllerScope.hasContent = true 
      controllerScope.updateContent = this.updateContent
      controllerScope.content = {}
      controllerScope.content = {}
    
      // to facilitate the menu / submenu structure of the old days we still keep this structure
      if ((controllerScope.type === 'panel') || (controllerScope.type === 'menu') || (controllerScope.type === 'section')) {
         this.menu[controllerScope.name] = controllerScope
      }
      if ((controllerScope.type === 'subMenu') || (controllerScope.type === 'dropdown')) {
         return this.subMenu[controllerScope.name] = controllerScope
      }
   }

   openMenu(userClicked = null) {
      return this.open = true
   }

   // this is not very foolproof, it depends on other elements updating correctly
   // can't think of another way to do it at the moment ¯\_(ツ)_/¯
   updateContent(type: any, hasContent: any) {
      this.content[type] = hasContent
      let wasUpdated = false
      _.mapObject(this.content, (hasContent: any, type: any) => {
         if (hasContent) {
            wasUpdated = true
            return this.hasContent = true
         }
      })
      if (!wasUpdated) {
         return this.hasContent = false
      }
   }

   closeMenu(userClicked = null) {
      if (userClicked !== null) {
         this.open = false // the user really closed it
         this.pinned = false
      }
      if ((userClicked === null) && !this.pinned) {
         this.open = false
         return this.pinned = false
      }
   }
   // else it's pinned, don't change the @open value

   pin() {
      return this.pinned = true
   }

   unpin() {
      return this.pinned = false
   }

   closeAllMenuTypeSubMenu(reallyCloseAll = false) {
      return _.mapObject(this.subMenu, (menu: any, name: any) => menu.closeMenu(reallyCloseAll))
   }

   closeAllMenuTypeMenu(reallyCloseAll = false) {
      return _.mapObject(this.menu, (menu: any, name: any) => menu.closeMenu(reallyCloseAll))
   }

   closeAllMenus(reallyCloseAll = false) {
      this.closeAllMenuTypeSubMenu(reallyCloseAll)
      return this.closeAllMenuTypeMenu(reallyCloseAll)
   }

   areAllMenuTypeMenuClosed() {
      const menus = _.values(this.menu)
      return this.allClosed = _.every(menus, (menu: any) => !menu.open)
   }

   areAllMenuTypeSubMenuClosed() {
      const subMenus = _.values(this.subMenu)
      return this.allClosed = _.every(subMenus, (menu: any) => !menu.open)
   }

   areAllMenusClosed() {
      return this.areAllMenuTypeMenuClosed() && this.areAllMenuTypeSubMenuClosed()
   }
}
   
MenuManagerService.$inject = []

angular.module('summonApp.services')
   .service("menuManagerService", MenuManagerService)
